import React from 'react';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

/**
 * ThreeColumns is a container component that can hold other
 * components where content authors can drag and drop whatever component into it.
 * It splits the grid into 3 columns
 * */
const ThreeColumns = (props) => {
  if (!props?.fields || !props.params) return <GenericPlaceholder componentName="ThreeColumns" />;
  const { heading } = props?.fields;

  return (
    <div
      className={clsx('content', 'info-list-and-cards-table', 'add-margins', props?.params?.Styles)}
    >
      {!!heading?.value && (
        <h3 className="ilact-heading">
          <Text field={heading} />
        </h3>
      )}
      <div className="ilact-content">
        <div className="ilact-content-col">
          <Placeholder name="listingBox" rendering={props.rendering} />
        </div>
        <div className="ilact-content-col">
          <Placeholder name="cardsTableBox1" rendering={props.rendering} />
        </div>
        <div className="ilact-content-col">
          <Placeholder name="cardsTableBox2" rendering={props.rendering} />
        </div>
      </div>
    </div>
  );
};

export default ThreeColumns;
